export default function ZxSpectrum() {
    return (
        <div style={{ width: "100%", height: "800px", textAlign: "center" }}>
            <iframe 
                src='https://archive.org/embed/zx_Wild_Bunch_The_1984_Firebird_Software'
                width="560" 
                height="384" 
                title="ZX Spectrum Game - The Wild Bunch"
                allowFullScreen             
            />
        </div>
    )
}